<template>
  <div class="wrap">
    <div class="container">
      <div class="custom-search" v-if="$route.meta.issearch">
        <div class="search-box">
          <input 
            type="text" 
            v-model="value1" 
            placeholder="请搜索商品.."
            placeholder-class="serch-inp"
            class="search-input"
            @keyup.enter="handleSearch"
          >
          <img 
            src="../images/index_serch.png" 
            style="position: absolute; left: 10px; top: 15px; height: 22px;"
            @click="handleSearch"
          />
        </div>
    </div>
      <van-swipe :autoplay="3000" indicator-color="#000000">
				<van-swipe-item v-for="(values, index) in imglist" :key="index" @click="goToIsedit()">
						<img :src="values" width="100%" height="666px"  />
				</van-swipe-item>
			</van-swipe>
      <div class="meili meili2"> <img class="meili"  src="../images/line1.png" alt=""></div>
      <div class="banb" style="width:100%;padding: 10px 0 30px 0;" @click="goToIsedit()">
        <van-swipe :autoplay="3000" indicator-color="#000000">
				<van-swipe-item v-for="(values, index) in imglist2" :key="index" @click=" goDetail(values.id)">
						<img :src="values.img" width="100%" height="500px"  />
				</van-swipe-item>
			</van-swipe>
      </div>
      <div @click="goToIsedit()" class="btn" style="border: 1px solid #000000;width: 130px;height: 40px;border-radius: 10px; color:#000000;font-size: 15px;display: flex;justify-content: center;
      align-items: center;margin: 0 auto;margin-bottom: 40px;">
        查看更多
      </div>
      <div class="main">
        <div class="meili">
          <img class="meili" src="../images/line.png" alt="">
        </div>
        <div class="main_img" @click="goToIsedit()">
            <div class="mainimgl">
              <img src="../images/index_banner4.png" style="width:90%;" mode="heightFix"/>
            </div>
            <div class="mainimgl">
              <img src="../images/index_banner5.png" style="width:90%;" mode="heightFix"/>
            </div>
            <!-- <div class="mainimgr">
              <img  src="../images/index_banner4.png"  style="width: 90%;" mode="heightFix"/>
              <img  src="../images/index_banner5.png" style="width: 90%;" mode="heightFix"/>
            </div> -->
        </div>
       
      </div>
      
    </div>
    <v-foot></v-foot>
    <!-- <van-tabbar route active-color="#E83AAE" >
      <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/kefu" icon="service-o">客服</van-tabbar-item>
      <van-tabbar-item replace to="/carts" icon="cart-o">购物车</van-tabbar-item>
      <van-tabbar-item replace to="/personal" icon="contact-o">我的</van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      imglist:[
        require('@/images/index_banner3.jpg') ,
        require('@/images/bannerlist3.jpg') ,
        require('@/images/bannerlist2.jpg') ,
      ],
      imglist2:[{
        img:require('@/images/Frame 2@2x.png'),
        id:902
      } ,
      {
        img:require('@/images/Frame 3@2x.png'),
        id:901
      },
      {
        img:require('@/images/Frame 4@2x.png'),
        id:896
      },
      {
        img:require('@/images/Frame 5@2x.png'),
        id:897
      },
      {
        img:require('@/images/Frame 6@2x.png'),
        id:866
      },{
        img:require('@/images/Frame 7@2x.png'),
        id:887
      },{
        img:require('@/images/Frame 8@2x.png'),
        id:897
      },
      ],
      pl_star: 3,
      value1: '',
      value2: "a",
      value3: "a",
      category_id: 0,
      keywords: "",
      page: 1,
      screening_price_id: 0,
      category_list: [],
      screening_price_list: [],
      goods_list: [],
      loading: false,
      finished: false,
      flag: true,
      nav_header: [],
			banner_list: [],
      active: 0,
      itemTabsShow: 0
    };
  },
  created() {
    this.getNav();
    this.getTab()
    if (this.$route.query.id !== undefined) {
      this.category_id = this.$route.query.id;
    }
    if (this.$route.query.keywords !== undefined) {
      this.keywords = this.$route.query.keywords;
    }
  },
  // watch: {
  //   $route: {
  //     handler() {
  //       this.category_id = this.$route.query.id;
  //       this.keywords = this.$route.query.keywords;
  //       this.searchGoods();
  //       //深度监听，同时也可监听到param参数变化
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: '/details', // 添加前导斜杠
        query: { id }
      })
    },
    handleSearch() {
      if (this.value1.trim()) {
        this.$router.push({
          path: '/isedit',
          query: {
            keywords: this.value1.trim(),
            fromSearch: true
          }
        });
      } else {
        this.$toast('请输入搜索关键词');
      }
    },
    getNav() {
      var _self = this;
      this.GET("/nav", function (data) {
        if (data.code == 0) {
          window.nav_header = data.data.header;
          _self.nav_header = data.data.header;
          window.nav_footer = data.data.footer;
          _self.cart_total = data.data.cart_total;
        }
      });
    },
    getData() {
      if (this.flag) {
        this.flag = false;
        var data = {
          category_id: this.category_id,
          keywords: this.keywords,
          page: this.page,
        };
        if (this.screening_price_id > 0) {
          data.screening_price_id = this.screening_price_id;
        }
        var url = "api/search/index";
        var _self = this;

        this.loading = true;
        this.POST(url, data, function (ret) {
          if (ret.code === 0) {
            _self.category_list = ret.data.category;
            _self.screening_price_list = ret.data.screening_price_list;
            if (_self.goods_list.length === 0) {
              _self.goods_list = ret.data.data;
            } else {
              _self.goods_list = _self.goods_list.concat(ret.data.data);
            }
            _self.finished = !ret.data.next_page;
            _self.page = ret.data.page;
          }
          _self.flag = true;
          _self.loading = false;
        });
      }
    },
    getTab() {
      var url = "/api/v1/index";
      var _self = this;
      this.GET(url,{},function (data) {
        if(data.code == 0){
          _self.banner_list 	= data.data.banner_list;
          console.log('bannerlist',data)
          // _self.hot_goods 	= data.data.goods_hot;
          // _self.new_goods 	= data.data.goods_new;
          // _self.price_symbol 	= data.data.price_symbol;
        }
      })
    },
    searchGoods(value,index) {
      // console.log('value',value)
      this.itemTabsShow = index
      if(value) this.category_id = value
      this.goods_list = [];
      this.page = 1;
      this.getData();
    },
    changeTab(index) {
      if(!index) index = 0
      // console.log('商品分类：',index)
      let id = this.nav_header[index].value || 0
      // console.log('商品id：',id)
      this.category_id = id || 0
      this.goods_list = [];
      this.page = 1;
      this.itemTabsShow = 0
      this.getData();
    },
    goToIsedit() {
      this.$router.push({
        path: '/isedit',
        query: {
          showAll: true
        }
      });
    },
  },
};
</script>
<style scoped>
.wrap {
  background: #E7EAEF;
  width: 100%;
}

.container {
  width: 100%;
}

.custom-search {
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  left: 0;
  top: 80px;
  z-index: 100;
  /* background: rgba(255,255,255,0.4); */
  padding: 0 20px;
}

.search-box {
  position: relative;
  display: flex;
  align-items: center;
  padding:0;
  background: none;
  box-shadow:none;
}

.search-input {
  width: 100%;
  height: 52px;
  padding: 0 41px;
  max-width: 800px;
    margin: 0 auto;
    background: rgba(120,104,87,0.2);
      /* background: rgba(255,255,255,0.4); */
    border-radius: 10px;

    color: #fff;
  font-size: 18px;
}

.search-input::placeholder {
  color: #fff;
}

.search-box img {
  cursor: pointer;
  transition: opacity 0.3s;
}

.search-box img:hover {
  opacity: 0.8;
}

.main{
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.meili{
  display: flex;
  margin: 6px auto;
  width: 320px;
    border-radius: 0px;
    align-items: center;
    justify-content: center;
    font-weight: bold;
font-size: 18px;
color: #000000;
line-height: 21px;
letter-spacing: 4px;
}
.main_img{
  display: flex;
  justify-content: center;
  align-items: center;
}
.mainimgl{
  width: 100%;
  height:288px
}
.mainimgr{
  width: 100%;
  height: 288px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.van-swipe-item,
.main_img,
.bann,
.banb {
  cursor: pointer;
}

.van-swipe-item:hover,
.main_img:hover,
.bann:hover,
.banb:hover {
  opacity: 0.9;
  transition: opacity 0.3s;
}
</style>